import styled from 'styled-components'

export const Root = styled.div`
  width: 100%;
`

export const Title = styled.h1`
  margin: 0px auto 26px;
  padding-top: 189px;
  text-align: center;
  font-size: 42px;
  font-weight: normal;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  text-transform: uppercase;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0px auto 18px;
    padding-top: 140px;
    font-size: 22px;	
  `};

  @media (max-width: 334px) {
    font-size: 15px;
  }
`

export const TitleWordWithImage = styled.span<{ isByRight?: boolean }>`
  display: inline-block;
  position: relative;
  margin: 0px 1.5% 2%;
  ${props => props.isByRight && 'padding-right: 3%;'}
`

export const TitleWordDecorated = styled.span`
  padding: 4px 15px;
  border-radius: 12px;
  font-size: 52px;
  background: black;
  color: #fbe438;
  position: relative;
  z-index: 2;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 4px 9px;
    border-radius: 5px;
    font-size: 24px;	
  `};
`

const TitleImage = styled.img`
  display: block;
  position: absolute;
  z-index: 1;
`

export const TitleHomer = styled(TitleImage)`
  bottom: 84%;
  left: 16%;
  width: 81%;
`
export const TitleCrab = styled(TitleImage)`
  bottom: 81%;
  left: 8%;
  width: 91%;
`

const TitleImageDecoration = styled.img`
  position: absolute;
  z-index: 3;
`

export const TitleCoins = styled(TitleImageDecoration)`
  bottom: 75%;
  left: 2%;
  width: 101%;
`

export const TitleBags = styled(TitleImageDecoration)`
  bottom: 85%;
  left: -7%;
  width: 113%;
`

export const TitleTextColored = styled.span`
  color: #e95a44;
`

export const Text = styled.p`
  margin: 0 auto 63px;
  max-width: 860px;
  text-align: center;
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  font-size: 20px;
  line-height: 1.5;
  color: black;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 auto 42px;
    font-size: 17px;	
  `};
`

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-self: stretch;

  & > *:first-child {
    margin-right: 12px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    & > *:first-child {
      margin-right: 8px;
    }
  `};
`
